import { Layout } from "react-grid-layout";
import { AccessType, AggregateType, DateRangeType, TimeframeType } from "../../common/enums/DRCXEnums";
import { NumericalFunctionEnum } from "../../common/enums/NumericalFunctionEnum";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { IAccessPermission } from "../../common/models/AccessPermission";
import { IEntityValueDeviceModel } from "../../common/models/IEntityValueModels";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { DurationOptionEnum } from "../../components/custom-duration-dialog/CustomDurationUtils";
import { AlarmNotificationsType } from "../../services/alarm-data-service/Models";
import { EDGDataGroupEnum } from "../../services/dynacard-data-service/Models";

export interface IDashboardTemplateQueryParams
{
    templateID?: number;
    templateType?: DashboardTemplateTypeEnum;
    templateObjectType?: DashboardTemplateObjectTypeEnum;
    name?: string;

    objectID?: number;
    objectType?: eLynxObjectTypeEnum;
}


//export type DashboardComponentType = 'section' | 'row' | 'column' | 'alarmNotificationCountChart' | 'dynacardGraph' | 'tagValueList' | 'tagValueGrid' | 'strokesPerMinute' | 'minMaxLoad' | 'objectGraph'
//| 'Text' | 'Image' | 'Gauge' | 'Map' | 'Alarm' | 'Notification' | 'AlarmNotification' | 'AlarmSetpointNotification' | 'AlarmRecipientNotification' | 'AlarmSetpointRecipientNotification' | 'AlarmObjectNotification' | 'AlarmSetpointObjectNotification' | 'Alarm

export enum DashboardComponentTypeEnum
{
    Section = 0,
    Row = 1,
    Column = 2,
    AlarmNotificationCountChart = 3,
    DynacardGraph = 4,
    TagValueList = 5,
    TagValueGrid = 6,
    StokesPerMinuteGraph = 7,
    MinMaxLoadGraph = 8,
    Graph = 9,

    // Leave space between reality and stupidity
    SummaryListing = 100,
    TankBattery = 101,
    AlarmDrawer = 102,
    DeviceMarketingReport = 103,
    Reporting = 104,
    Mapping = 105,
    ImageView = 106,
    HistoricalData = 107,
    ObjectHistory = 108,
    ObjectProperties = 109,
    ObjectTagValues = 110,
}

export type DashboardComponentTypeName = 'Section' | 'Row' | 'Column' | 
                                            'AlarmNotificationCountChart' | 'DynacardGraph' | 
                                            'TagValueList' | 'TagValueGrid' | 
                                            'StrokesPerMinute' | 'MinMaxLoad' | 
                                            'ObjectGraph' | 'SummaryListing' | 'TankBattery' | 'AlarmDrawer' |
                                            'DeviceMarketingReport' | 'Reporting' | 'Mapping' | 'ImageView' | 'HistoricalData' | 'ObjectHistory' |
                                            'ObjectProperties' | 'ObjectTagValues';


// export type DashboardDevicePropertyTypeName = 'name' | 'phoneticname' | 'identifier' | 'deviceTypeID' | 'validateGasAnalysis' | 
//                                                 'commInfo' | 'deviceLocation' | 'latitude' | 'longitude' | 
//                                                 // stand alone tank properties
//                                                 'styleID' |'height' | 'resourceUnitsPerInch' | 'capacity' |
//                                                 'pollingScheduleName' | 
//                                                 // ??
//                                                 'externalContentTitle' | 'externalContentUrl';

export enum DashboardDevicePropertyNameEnum {
    Name = 'name',
    Phoneticname = 'phoneticname',
    Identifier = 'identifier',
    DeviceTypeID = 'deviceTypeID',
    ValidateGasAnalysis = 'validateGasAnalysis',
    CommInfo = 'commInfo',
    DeviceLocation = 'deviceLocation',
    Latitude = 'latitude',
    Longitude = 'longitude',
    TankProperties = 'tankProperties',
    //StyleID = 'styleID',
    //Height = 'height',
    //ResourceUnitsPerInch = 'resourceUnitsPerInch',
    //Capacity = 'capacity',
    PollingScheduleName = 'pollingScheduleName',
    ExternalContent = 'externalContent',
    
}


export interface IDashboardComponent extends Layout {

    id: string;
    title?: string;
    componentType: DashboardComponentTypeEnum | DashboardComponentTypeName;

    // for context when running the template
    groupID?: number;                              /// always assume route context?
    contextObject?: IeLynxObject;                  /// always assume route context?

    // these will be set if there is a specific target object
    objectID?: number;
    objectType?: eLynxObjectTypeEnum;

    entityDeleted?: boolean;

    maximized?: boolean;
    hide?: boolean;

    // ui utiltiy
    isNew?: boolean;
}

export interface IObjectGraphDashboardComponent extends IDashboardComponent {

    configurationID: number;

    displayAlarms: boolean;
    displayDataQualityEvents: boolean;
    displayDiagnosticEvents: boolean;
    displayManualEvents: boolean;
    displayLegend: boolean;
    displayMemos: boolean;
    displaySettingsChanges: boolean;
    displaySimulationDataQualityEvents: boolean;
    displaySimulationDiagnosticEvents: boolean;

    durationOption: DurationOptionEnum;
    startDate: Date | undefined;
    endDate: Date | undefined;

    //configurationName?: string; // for display purposes
}

export interface ITankBatteryDashboardComponent extends IDashboardComponent {

    displayAlarms: boolean;
    displayDataQualityEvents: boolean;
    displayDiagnosticEvents: boolean;
    displayManualEvents: boolean;
    displayLegend: boolean;
    displayMemos: boolean;
    displaySettingsChanges: boolean;

    durationOption: DurationOptionEnum;
    startDate: Date | undefined;
    endDate: Date | undefined;

    //tankBatteryName?: string;
}

export interface ITagValueDefinition {
    
    //[JsonProperty("gtf")]
    //public TimeframeType GroupingTimeframe: boolean;
    groupingTimeframe: TimeframeType;

    //[JsonProperty("gf")]
    //public NumericalFunctionEnum? GroupingFunction: boolean;
    groupingFunction: NumericalFunctionEnum;

    // [JsonProperty("at")]
    // public AggregateType AggregationType: boolean;
    aggregationType: AggregateType;

    //[JsonProperty("ap")]
    //public int AggregationPeriod: boolean;
    aggregationPeriod: number;

    //[JsonProperty("af")]
    //public NumericalFunctionEnum AggregationFunction: boolean;
    aggregationFunction: NumericalFunctionEnum;

    //[JsonProperty("asdr")]
    //public DateRangeType? AggregationStepDateRange: boolean;
    aggregationStepDateRange?: DateRangeType;

    //[JsonProperty("as")]
    //public int? AggregationStep: boolean;
    aggregationStep?: number;

    //?? needed since most likely overridden with start and end times
    //[JsonProperty("tf")]
    //public DRCXConfigurationTimeframe Timeframe: boolean;


    //[JsonProperty("ot")]
    //public eLynxObjectTypeEnum ObjectType: boolean;
    objectType?: eLynxObjectTypeEnum;

    //[JsonProperty("mc")]
    //public int? MaxCount: boolean;
    //[JsonProperty("lbl")]
    //public string Label: boolean;
    label?: string;


    // tid?: number;
    // ttid?: number;


    // Results ??? jsonignore?
    //[JsonProperty("obj")]
    //public eLynxObject Object: boolean;
    //[JsonProperty("tvs")]
    //public List<TagValue> TagValues: boolean; = [];
    //[JsonProperty("tgn")]
    //public string TagName: boolean;
    //[JsonProperty("tgi")]
    //public int TagID: boolean;

    tatID: number,
    tatTypeID: number,
}

// export interface ITatValueDefinition extends ITagValueDefinition {
//     tid: number;
// }

// export interface ITatTypeValueDefinition extends ITagValueDefinition {
//     ttid: number;
// }

// export type TagValueDefinition = {
// } & ITatValueDefinition | ITatTypeValueDefinition;

export interface ITagValueConfiguration {
    title?: string;
    showTitle: boolean;
    showObjectName: boolean;
    objects: IeLynxObject[];
    valueDefinitions: ITagValueDefinition[];
    //valueDefinitions: TagValueDefinition[];
}

export interface ITagValueListDashboardComponent extends IDashboardComponent {
    // these are the options needed to get the data
    durationOption: DurationOptionEnum;
    startDate?: Date;
    endDate?: Date;
    configuration: ITagValueConfiguration[];
}

export interface ITagValueGridRowDefinition {
    label: string, 
    rowTATs: number[];
}

export interface ITagValueGridDashboardComponent extends ITagValueListDashboardComponent {
    overrideStandardLayout: boolean;
    columnLabels?: string[];
    rowDefinitions?: ITagValueGridRowDefinition[];
}

export interface IDynacardDashboardComponent extends IDashboardComponent {
    startDate?: Date;
    endDate?: Date;
    dynaCardTypes?: EDGDataGroupEnum[];    
}

export interface IAlarmNotificationCountChartDashboardComponent extends IDashboardComponent {
        notificationsType: AlarmNotificationsType;      /// AlarmNotificationsType
        // groupID?: number;                              /// always assume route context?

        durationOption: DurationOptionEnum;
        startDate?: Date;
        endDate?: Date;

        showEmail: boolean;
        showVoice: boolean;
        showText: boolean;
}

export interface ISummaryListingDashboardComponent extends IDashboardComponent {

    //overrideGroupID?: number;
    configurationID: number;
    //configurationName?: string; // for display purposes
}

export interface IAlarmDrawerDashboardComponent extends IDashboardComponent {

}

export interface IDeviceMarketingReportDashboardComponent extends IDashboardComponent {

}


export interface IReportingDashboardComponent extends IDashboardComponent {
    configurationID: number;
}

export interface IMappingDashboardComponent extends IDashboardComponent {
    configurationID: number;
}

export interface IImageViewDashboardComponent extends IDashboardComponent {
    configurationID: number;
    tabIndex?: number;
}

export interface IHistoricalDataDashboardComponent extends IDashboardComponent {

    tagThreadID: number;

    durationOption: DurationOptionEnum;
    startDate: Date | undefined;
    endDate: Date | undefined;
}

export interface IObjectHistoryDashboardComponent extends IDashboardComponent {

    showMemos: boolean;
    showSettingsChanges: boolean;
    showAlarms: boolean;
    showDiagnosticEvents: boolean;
    showDataQualityEvents: boolean;
    showFormEvents: boolean;
    showManualEvents: boolean;
    durationOption: DurationOptionEnum;
    startDate: Date | undefined;
    endDate: Date | undefined;
}

export interface IObjectPropertiesDashboardComponent<T> extends IDashboardComponent {
    propertyNames: T[];
}

export interface IDevicePropertiesDashboardComponent extends IObjectPropertiesDashboardComponent<DashboardDevicePropertyNameEnum> {

}

export interface IObjectTagValuesDashboardComponent extends IDashboardComponent {
    configurationID: number;

    showUIDColumn: boolean;
    showLiveDataColumn: boolean;
    showLookupListColumn: boolean;
    showFormulaColumn: boolean;

}

export interface IDashboardColumn extends IDashboardComponent {
    
    width?: number | string | undefined; // 'auto | '100%' | '50%' | 300px | 300
    maxWidth? : number | string | undefined; // 'auto | '100%' | '50%' | 300px | 300
    components: IDashboardComponent[];
}

export interface IDashboardRow extends IDashboardComponent {


    //backgroundColor: string;
    height: number | string; // 'auto | '100%' | '50%' | 300px | 300
    minHeight: number | string | undefined; // 'auto | '100%' | '50%' | 300px | 300

    columns: IDashboardColumn[];

}


export interface IDashboardSection extends IDashboardComponent {
    rows: IDashboardRow[];
}



export interface IAccessibleDashboardTemplates {
    defaultConfigurationID: number | undefined;
    userPermissions: IAccessPermission[];
    templates: IDashboardTemplate[];
}


export interface IDashboardTemplate {
    id: number;
    name: string;
    templateType: DashboardTemplateTypeEnum;
    templateObjectType: DashboardTemplateObjectTypeEnum;
    template: string;
    createdBy?: string;
    createdTimestamp?: Date;
    modifiedBy?: string;
    modifiedTimestamp?: Date;
    deleted: boolean;
    deletedBy?: string;
    deletedTimestamp?: Date;
    access: AccessType 
}

export enum DashboardTemplateTypeEnum {
    Internal = 0,
    UserDefined = 1
}

export enum DashboardTemplateObjectTypeEnum {
    Group = 0,
    Device = 1,
    Tank = 2,
    Well = 3,
}


export interface IDashboardTemplateDefinition
{
    id: number;
    name: string;
    templateType: DashboardTemplateTypeEnum;
    templateObjectType: DashboardTemplateObjectTypeEnum;
    createdBy: string;
    createdOn: Date;
    //section: IDashboardSection;
    layout: IDashboardComponent[]
    access: AccessType;
}



export const defaultDashboardDefinition: IDashboardTemplateDefinition = {
    id: -1,
    name: 'New Dashboard',
    templateType: DashboardTemplateTypeEnum.UserDefined,
    templateObjectType: DashboardTemplateObjectTypeEnum.Device,
    createdBy: '',
    createdOn: new Date(),
    access: AccessType.Private,
    layout: []
    // section: {
    //     id:  UUID.generate(),
    //     componentType: DashboardComponentTypeEnum.Section,
    //     rows: [{
    //         id: UUID.generate(),
    //         componentType: DashboardComponentTypeEnum.Row,
    //         height: '50%',
    //         minHeight: 'auto',
    //         columns: [{
    //             id: UUID.generate(),
    //             title: 'Column 1',
    //             componentType: DashboardComponentTypeEnum.Column,
    //             width: '50%',
    //             maxWidth: undefined,
    //             components: []
    //         },{
    //             id: UUID.generate(),
    //             title: 'Column 2',
    //             componentType: DashboardComponentTypeEnum.Column,
    //             width: '50%',
    //             maxWidth: undefined,
    //             components: []
    //         }]
    //     },{
    //         id: UUID.generate(),
    //         componentType: DashboardComponentTypeEnum.Row,
    //         height: '50%',
    //         minHeight: 'auto',
    //         columns: [{
    //             id: UUID.generate(),
    //             title: 'Column 3',
    //             componentType: DashboardComponentTypeEnum.Column,
    //             width: '50%',
    //             maxWidth: undefined,
    //             components: []
    //         },{
    //             id: UUID.generate(),
    //             title: 'Column 4',
    //             componentType: DashboardComponentTypeEnum.Column,
    //             width: '50%',
    //             maxWidth: undefined,
    //             components: []
    //         }]
    //     }]
    // }
};



export interface ITagValueListModel {
    title: string;
    values: IEntityValueDeviceModel[];
}

export interface ITagValueGridModel extends ITagValueListModel{
}






export interface IDashboardDefault {
    templateID: number;
    forCurrentUser: boolean;
    forUsersWithoutDefault: boolean;
    forAllUsers: boolean;
    forAllObjectsInCurrentGroupWithoutDefault: boolean;
}

export interface IDashboardDefaultOptions {
    groupName: string;
    objectName?: string;
    isForCurrentUser: boolean;
    isForUsersWithoutDefault: boolean;
    isForAllUsers: boolean;
    isForAllObjectsInCurrentGroupWithoutDefault: boolean;
}

